<template>
  <div class="work-order-visual" aria-hidden="true">
    <div class="work-order-visual__screen">
      <div class="work-order-visual__title">
        <span class="work-order-visual__name">Werkbon WB-0318</span>
        <ShowcasePill tone="green">INGEPLAND</ShowcasePill>
        <span class="work-order-visual__button">Stuur update</span>
      </div>

      <strong class="work-order-visual__address">L. Mulder, Kerkstraat 14, Nijkerk</strong>
      <span class="work-order-visual__subtitle">Montage 3x rolluik + 1x knikarmscherm</span>

      <span class="work-order-visual__label">PLANNINGSREGELS</span>
      <div class="work-order-visual__lines">
        <div v-for="line in planningLines" :key="line.task" class="work-order-visual__line">
          <div class="work-order-visual__day">
            <small>{{ line.weekday }}</small>
            <span>{{ line.date }}</span>
          </div>
          <span class="work-order-visual__task">{{ line.task }}</span>
          <span class="work-order-visual__installer">
            <ShowcaseAvatar :person="line.installer" />
            {{ line.time }}
          </span>
        </div>
      </div>

      <span class="work-order-visual__label">PAKBON</span>
      <div class="work-order-visual__field">
        <span>4 producten, 23 onderdelen</span>
        <span class="work-order-visual__link">Bekijk</span>
      </div>
    </div>

    <div class="work-order-visual__chip">
      <img :src="statusIcon" alt="" width="8" height="8" />
      <span>Klant ontving: "Cas is onderweg, verwacht rond 08:30"</span>
    </div>
  </div>
</template>

<script>
  import statusIcon from '@/assets/img/login/status-online.svg';

  import ShowcaseAvatar from './ShowcaseAvatar.vue';
  import ShowcasePill from './ShowcasePill.vue';

  export default {
    name: 'WorkOrderVisual',
    components: { ShowcaseAvatar, ShowcasePill },
    setup() {
      const planningLines = [
        {
          weekday: 'WO',
          date: '15',
          task: 'Levering materiaal',
          installer: 'sander',
          time: '08:00 tot 10:00',
        },
        { weekday: 'DO', date: '16', task: 'Montage rolluiken', installer: 'cas', time: 'Hele dag' },
        { weekday: 'VR', date: '17', task: 'Montage scherm', installer: 'cas', time: 'Ochtend' },
      ];

      return { planningLines, statusIcon };
    },
  };
</script>

<style scoped lang="scss">
  .work-order-visual {
    position: relative;
    width: 520px;
    max-width: 100%;
    color: var(--showcase-ink);

    &__screen {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 18px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 10px;
      background-color: var(--white);
      box-shadow:
        0 1px 2px rgba(0, 9, 33, 0.06),
        0 8px 24px rgba(0, 9, 33, 0.07);
    }

    &__title {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
      margin-bottom: 14px;
    }

    &__name {
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;
      white-space: nowrap;
    }

    &__button {
      margin-left: auto;
      padding: 3px 10px;
      border: 1px solid var(--showcase-primary);
      border-radius: 6px;
      background-color: var(--showcase-primary);
      color: var(--white);
      font-size: 13px;
      line-height: 20px;
      white-space: nowrap;
    }

    &__address {
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
    }

    &__subtitle {
      color: var(--showcase-text);
      font-size: 12px;
      line-height: 20px;
    }

    &__label {
      padding: 14px 0 4px;
      color: var(--showcase-muted);
      font-size: 10px;
      font-weight: 500;
      line-height: 15px;
      letter-spacing: 0.4px;
    }

    &__lines + &__label {
      padding-top: 10px;
    }

    &__lines {
      display: flex;
      flex-direction: column;
      gap: 6px;
      width: 100%;
    }

    &__line {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 10px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 6px;
      font-size: 13px;
      line-height: 20px;
      white-space: nowrap;
    }

    &__installer {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    &__day {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 40px;
      small {
        color: var(--showcase-muted);
        font-size: 10px;
        line-height: 11px;
        letter-spacing: 0.4px;
      }
      span {
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
      }
    }

    &__task {
      flex: 1;
      min-width: 0;
    }

    &__field {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 7px 10px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 6px;
      font-size: 13px;
      line-height: 20px;
      white-space: nowrap;
    }

    &__link {
      color: var(--showcase-primary);
    }

    &__chip {
      position: absolute;
      bottom: -8px;
      left: -45px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 7px 11px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 8px;
      background-color: var(--white);
      font-size: 12.5px;
      line-height: 18px;
      white-space: nowrap;
      box-shadow:
        0 1px 2px rgba(0, 9, 33, 0.06),
        0 8px 24px rgba(0, 9, 33, 0.07);
    }
  }
</style>
